import { Box } from '@mui/material';

import { useState, useEffect } from 'react';

import styles from '../JobScheduler.module.scss';

import SelectComponent from '../../../../common/components/SelectNumComp/SelectComponent';

interface IMinuteProps {
	handleChange: (val: number | string) => void;
}

type OptionType = {
	value: number;
	label: number;
};

const minutesList: OptionType[] = [
	{ label: 1, value: 1 },
	{ label: 2, value: 2 },
	{ label: 3, value: 3 },
	{ label: 4, value: 4 },
	{ label: 5, value: 5 },
	{ label: 6, value: 6 },
	{ label: 10, value: 10 },
	{ label: 15, value: 15 },
	{ label: 20, value: 20 },
	{ label: 30, value: 30 },
];

const MinuteComp = (props: IMinuteProps) => {
	const { handleChange } = props;

	const [minutes] = useState<number>(1);

	useEffect(() => {
		handleChange(minutes);
	}, [minutes]);

	return (
		<Box className={styles['select-align']}>
			<span>Every</span>
			<SelectComponent
				type="number"
				defaultValue={minutes}
				selectList={minutesList}
				handleValueChange={handleChange}
			/>
			<span>minute(s)</span>
		</Box>
	);
};

export default MinuteComp;
